'use strict';

var _jquery = require('./lib/jquery-3.3.1.min');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ajax = {
    request: function request(param) {
        _jquery2["default"].ajax({
            type: param.method || 'get',
            url: param.url || '',
            data: param.data || '',
            dataType: param.type || 'jsonp',
            jsonp: "callback",
            success: function success(res) {
                typeof param.success === 'function' && param.success(res);
            },
            error: function error(errMsg) {
                typeof param.error === 'function' && param.error(errMsg);
            }
        });
    }
};
module.exports = ajax;


//////////////////
// WEBPACK FOOTER
// ./src/bsjyy/js/ajax.js
// module id = 105
// module chunks = 7 8